<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Radio Button</h1>
			</div>
		</div>
    <!--Content-->
		<div id="content">
      <div class="types">
        <h2>Types</h2>
        <h3>Single</h3>
        <mt-radio-button id="item-0" label="Label" :checked="true"  />

        <h3>Group</h3>
        <mt-radio-button type="group" v-for="item in items" :key="item.id" :id="item.id" :label="item.item" :checked="item.checked"  />
      </div>
      <div class="style">
        <h2>Style</h2>
        <h3>Colors</h3>
        <div class="left mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="colors" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Checked:</p>
          <p>Background: #055AFE</p>
          <p>Text: #485464</p>
          <br />
          <p>Hover:</p>
          <p>Border: #055AFE </p>
          <p>Text: #485464</p>
          <br />
          <p>Unchecked:</p>
          <p>Border: #B2C0D0</p>
          <p>Text: #485464</p>
          <br />
          <p>Unchecked disable:</p>
          <p>Background: #EDEFF3</p>
          <p>Border: #055AFE </p>
          <p>Text: #B2C0D0</p>
        </div>

        <h3>Sizing</h3>
        <div class="left mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="sizing" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Width: 18px</p>
          <p>Height: 18px</p>
          <p>Border: 1px</p>
          <p>Text: 14px</p>
          <p>Horizontal padding: 10px</p>
          <p>Vertical padding: 15px</p>
        </div>
      </div>
		</div>

  </div>
</template>

<script>
export default {
  name: 'radiobutton-page',
  data () {
    return {
      colors: require('@/assets/radio-buttons-style-colors.svg'),
      sizing: require('@/assets/radio-buttons-style-sizing.svg'),
      items: [
        { 'id': 'item-1', 'name': 'itemGroup', 'item': 'Label 01', 'checked': true },
        { 'id': 'item-2', 'name': 'itemGroup', 'item': 'Label 02', 'checked': false },
        { 'id': 'item-3', 'name': 'itemGroup', 'item': 'Label 03', 'checked': false },
      ],
    }
  },
}
</script>
<style lang="scss" scoped>
h3 { font-weight: normal; }
p { margin-top: 0; margin-bottom: 5px; }
.types .mt-radio-button {
  text-align: left;
  padding-left: 60%;
  margin-bottom: 30px;
  &.group-radioButton {
    display: block;
    margin-bottom: 15px;
  }
}
.styles .mt-radio-button {
  margin: 0 auto;
  width: 78%;
}
.right {
  width: 270px;
  padding: 2%;
  float: left;
  .button-wrap{
    padding-right: 20px;
  }
}
.left{
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 540px;
  float: left;
  position: relative;
  margin-bottom: 2em;
  &.imgbox {
    display: block;
    img { width: 100%; }
  }
}
</style>





// WEBPACK FOOTER //
// RadioButton.vue?6fb247f6